import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { WEEK_DAYS } from "@shared/helpers/constants";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { Opportunity } from "../opportunity";
import { DateAndTimeRangeEntityConfig } from "./config";
import { DateAndTimeRangeFilters } from "./filters";
import { DateAndTimeRangeMethods } from "./methods";

@HyperEntity("date-and-time-range", DateAndTimeRangeEntityConfig)
export class DateAndTimeRange extends extender(
  DateAndTimeRangeFilters,
  DateAndTimeRangeMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "opportunity_id" })
  opportunityId = "";

  @Relations.toOne<DateAndTimeRange, Opportunity>(
    () => Opportunity,
    "opportunityId",
  )
  opportunity?: Opportunity;

  @Fields.date({ dbName: "start_time" })
  startTime: Date = new Date();

  @Fields.date({ dbName: "end_time" })
  endTime: Date = new Date();

  @Fields.dateOnly({ dbName: "start_date" })
  startDate: Date = new Date();

  @Fields.dateOnly({ dbName: "end_date" })
  endDate: Date = new Date();

  @Fields.literal(() => WEEK_DAYS, { dbName: "day_in_week" })
  dayInWeek: (typeof WEEK_DAYS)[number] = WEEK_DAYS[new Date().getDay()];
}
